import styled from "styled-components";

import {
  alpha,
  bp,
  flexColumn,
  flexSpBetween,
  media,
  rem,
} from "@styles/Utilities.styled";


export const StyledHeader = styled.div`
  /* .header { */
  ${flexColumn}
  gap: 1.5rem;
  padding-top: 2rem;
  padding-bottom: 1rem;
  border-bottom: 1px solid ${alpha("var(--clr-black)", 0.1)};

  ${media(bp.medium)} {
    ${flexSpBetween}
    flex-direction: row;
  }

  h1 {
    font-weight: 500;
    font-size: ${rem(20)};
  }
  /* } */
`;
